
const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A2647] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <i className="ri-shield-cross-line text-xl text-[#0A2647]"></i>
              </div>
              <span className="text-xl font-bold">InsuranceServicesTX</span>
            </div>
            <p className="text-white/70 leading-relaxed mb-6 max-w-md">
              Your trusted partner for private health insurance in Austin, Texas. We specialize in 
              personalized healthcare solutions for individuals, families, and small businesses. 
              Let us help you find the coverage that's right for you.
            </p>
            <a
              href="tel:512-306-6245"
              className="inline-flex items-center gap-2 text-[#2196F3] font-semibold hover:text-[#64B5F6] transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              512-306-6245
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="font-semibold text-lg mb-6">Quick Links</h5>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-white transition-colors cursor-pointer"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h5 className="font-semibold text-lg mb-6">Contact Info</h5>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#2196F3] mt-1"></i>
                <span className="text-white/70">
                  8708 S Congress Ave<br />
                  Austin, TX 78745
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#2196F3]"></i>
                <a href="tel:512-306-6245" className="text-white/70 hover:text-white transition-colors cursor-pointer">
                  512-306-6245
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-time-line text-[#2196F3]"></i>
                <span className="text-white/70">Open 7 Days - 4 Hours Daily</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} InsuranceServicesTX. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-white/60 hover:text-white/80 text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
